// @flow

import * as React from "react";
import cx from "classnames";
import { uid } from "uid";
import type { InputType, MetaType } from "../../../types/form";

import InputWrapper from "../Shared/InputWrapper/InputWrapper";
import styles from "../Shared/Input.scss";
import type { ReactElementRef } from "../../../types/react";

type TextInputProps = {
  additionalClasses: string,
  autoComplete: string,
  label: string,
  placeholder: string,
  sideSymbol: ?() => React.Node,
  input: InputType,
  meta: MetaType,
  "data-testid": ?string,
  isDisabled: boolean,
  isLocked: ?boolean,
  innerRef: ?ReactElementRef<HTMLInputElement>
};

const TextInput = ({
  additionalClasses,
  autoComplete,
  isDisabled,
  isLocked,
  label,
  placeholder,
  sideSymbol,
  input,
  meta,
  // eslint-disable-next-line react/prop-types
  "data-testid": dataTestid,
  innerRef,
  ...restProps
}: TextInputProps) => (
  <InputWrapper sideSymbol={sideSymbol} input={input} meta={meta} isDisabled={isDisabled}>
    <input
      {...input}
      value={input?.value || ""}
      className={cx(styles.input, {
        [styles.removeAdditionalPadding]: !sideSymbol,
        [styles.isLocked]: isLocked,
        [additionalClasses]: !!additionalClasses
      })}
      // disable HTML autoComplete
      name={null}
      placeholder={placeholder}
      type="text"
      // uid prevents Chrome's autofill
      autoComplete={autoComplete === "off" ? uid(10) : autoComplete}
      aria-label={label}
      data-testid={dataTestid || `textInput:${input.name}`}
      data-name={input && input.name}
      disabled={isDisabled || isLocked}
      ref={innerRef}
      {...restProps}
    />
  </InputWrapper>
);

TextInput.defaultProps = {
  additionalClasses: "",
  autoComplete: "off",
  isDisabled: false,
  placeholder: "",
  sideSymbol: null,
  label: "",
  input: null,
  "data-testid": null,
  innerRef: null
};

export default TextInput;
